/**
 * Deterministic "How it connects" copy from domain result + canonical roles.
 * Does not decide compatibility. Does not invent cables, ports, or adapters.
 */

export function buildConnectionFacts(viewModel) {
  if (!viewModel) return [];
  const display = (viewModel.selectedProducts || []).find((row) => row.role === 'DISPLAY');
  const sonar = (viewModel.selectedProducts || []).find((row) => row.role === 'LIVE_SONAR');
  const facts = [];

  if (display?.name) {
    facts.push(`${display.name} is the selected display.`);
  }
  if (sonar?.name) {
    facts.push(`${sonar.name} is the selected LiveScope sonar.`);
  }

  const sonarRoles = sonar?.roles || [];
  const missingGls = (viewModel.actions?.add || []).some((row) => row.slug === 'garmin-gls-10');
  const hasDirectProcessor =
    sonarRoles.includes('SONAR_PROCESSOR_INTERFACE')
    && !missingGls
    && (viewModel.pairStatus === 'COMPATIBLE' || viewModel.pairStatus === 'COMPATIBLE_WITH_REQUIREMENT');

  if (hasDirectProcessor) {
    facts.push(
      'This LiveScope 2 path includes the sonar processor interface, so a separate GLS 10 is not required.'
    );
  } else if (missingGls) {
    facts.push('This LiveScope path requires a GLS 10 sonar processor.');
  }

  return facts;
}
